import { Preferences } from '@capacitor/preferences';

/**
 * Secure token storage — web/Capacitor equivalent of the legacy
 * `stores/secure` (expo-secure-store).
 *
 * Tokens live in @capacitor/preferences → Keychain (iOS) /
 * EncryptedSharedPreferences (Android) in the native shell, and an
 * IndexedDB-backed store in the browser. Never use localStorage for tokens.
 */

const BEARER_TOKEN_KEY = 'racore.bearerToken';
const REFRESH_TOKEN_KEY = 'racore.refreshToken';

export interface Tokens {
  bearerToken: string | null;
  refreshToken: string | null;
}

export const saveToken = async (bearerToken: string, refreshToken: string): Promise<void> => {
  await Promise.all([
    Preferences.set({ key: BEARER_TOKEN_KEY, value: bearerToken }),
    Preferences.set({ key: REFRESH_TOKEN_KEY, value: refreshToken }),
  ]);
};

export const getTokens = async (): Promise<Tokens> => {
  const [bearer, refresh] = await Promise.all([
    Preferences.get({ key: BEARER_TOKEN_KEY }),
    Preferences.get({ key: REFRESH_TOKEN_KEY }),
  ]);
  return { bearerToken: bearer.value, refreshToken: refresh.value };
};

export const updateBearerToken = async (bearerToken: string): Promise<void> => {
  await Preferences.set({ key: BEARER_TOKEN_KEY, value: bearerToken });
};

export const removeToken = async (): Promise<void> => {
  await Promise.all([
    Preferences.remove({ key: BEARER_TOKEN_KEY }),
    Preferences.remove({ key: REFRESH_TOKEN_KEY }),
  ]);
};
